import loadable from '@loadable/component';
import LoadingComponentLoadable from '../../components/Loading/Lazy';

const LoginLoadable = loadable(() => import(/* webpackChunkName: "privacy-policy-page" */ './index'), {
  fallback: <LoadingComponentLoadable />,
});

export default LoginLoadable;
